const typographyPlugin = require('../../../lib/utils/tailwind/typography.plugin');

const prose =
  (typographyConfig, { brand }) =>
  (theme) => {
    const typographyStyles = typographyPlugin.getUtilities(theme, typographyConfig, { brand });

    const DEFAULT = {
      '--tw-prose-body': theme('colors.black'),
      '--tw-prose-headings': theme('colors.black'),
      '--tw-prose-links': theme('colors.hn-primary[700]'),
      '--tw-prose-links-hover': theme('colors.hn-primary[700]'),
      '--tw-prose-links-visited': theme('colors.hn-primary[900]'),
      '--tw-prose-bullets': theme('colors.black'),
      '--tw-prose-counters': theme('colors.black'),

      'max-width': '100%',

      ...typographyStyles['.text-hn-body-md'],

      a: {
        textDecoration: 'none',
        fontWeight: '700',

        '&:hover': {
          color: 'var(--tw-prose-links-hover)',
          textDecoration: 'underline',
        },
        '&:visited': {
          color: 'var(--tw-prose-links-visited)',
        },
      },
      ol: {
        marginBottom: `${theme('spacing[3]')} !important`,
      },
      ul: {
        marginBottom: `${theme('spacing[3]')} !important`,
      },
      li: {
        marginBottom: `0 !important`,
        paddingLeft: 0,
      },
    };

    const sm = {
      ...typographyStyles['.text-hn-body-sm'],
      h1: typographyStyles['.text-hn-headline-lg'],
      h2: typographyStyles['.text-hn-headline-md'],
      h3: typographyStyles['.text-hn-headline-sm'],
      h4: typographyStyles['.text-hn-headline-sm'],
      h5: typographyStyles['.text-hn-headline-xs'],
      h6: typographyStyles['.text-hn-headline-xs'],
      p: typographyStyles['.text-hn-body-sm'],
      ol: typographyStyles['.text-hn-body-sm'],
      ul: typographyStyles['.text-hn-body-sm'],
      li: typographyStyles['.text-hn-body-sm'],
    };

    const lg = {
      ...typographyStyles['.text-hn-body-md'],
      h1: typographyStyles['.text-hn-headline-xl'],
      h2: typographyStyles['.text-hn-headline-lg'],
      h3: typographyStyles['.text-hn-headline-md'],
      h4: typographyStyles['.text-hn-headline-md'],
      h5: typographyStyles['.text-hn-headline-sm'],
      h6: typographyStyles['.text-hn-headline-xs'],
      p: typographyStyles['.text-hn-body-md'],
      ol: typographyStyles['.text-hn-body-md'],
      ul: typographyStyles['.text-hn-body-md'],
      li: typographyStyles['.text-hn-body-md'],
    };

    const authorDetails = {
      sm: {
        ...sm,
        '--tw-prose-links': theme('colors.hn-primary[700]'),
        '--tw-prose-links-hover': theme('colors.hn-primary[700]'),
        '--tw-prose-links-visited': theme('colors.hn-primary[900]'),
        ...typographyStyles['.text-hn-body-xs'],
        p: typographyStyles['.text-hn-body-xs'],
      },
      lg: {
        ...lg,
        '--tw-prose-links': theme('colors.hn-primary[700]'),
        '--tw-prose-links-hover': theme('colors.hn-primary[700]'),
        '--tw-prose-links-visited': theme('colors.hn-primary[900]'),
        ...typographyStyles['.text-hn-body-sm'],
        p: typographyStyles['.text-hn-body-sm'],
      },
    };

    const factbox = {
      sm: {
        ...typographyStyles['.text-hn-body-xs'],
        p: typographyStyles['.text-hn-body-xs'],
        ol: typographyStyles['.text-hn-body-xs'],
        ul: typographyStyles['.text-hn-body-xs'],
        li: typographyStyles['.text-hn-body-xs'],
        h2: typographyStyles['.text-hn-headline-sm'],
        h3: typographyStyles['.text-hn-headline-xs'],
      },
      lg: {
        ...typographyStyles['.text-hn-body-sm'],
        p: typographyStyles['.text-hn-body-sm'],
        ol: typographyStyles['.text-hn-body-sm'],
        ul: typographyStyles['.text-hn-body-sm'],
        li: typographyStyles['.text-hn-body-sm'],
        h2: typographyStyles['.text-hn-headline-md'],
        h3: typographyStyles['.text-hn-headline-sm'],
      },
    };

    const coverbox = {
      sm: {
        ...typographyStyles['.text-hn-body-sm'],
        p: typographyStyles['.text-hn-body-sm'],
      },
      lg: {
        ...typographyStyles['.text-hn-body-sm'],
        p: typographyStyles['.text-hn-body-sm'],
      },
    };

    return {
      DEFAULT: { css: DEFAULT },
      sm: { css: sm },
      lg: { css: lg },
      'authorDetails-sm': { css: authorDetails.sm },
      'authorDetails-lg': { css: authorDetails.lg },
      'factbox-sm': { css: factbox.sm },
      'factbox-lg': { css: factbox.lg },
      'coverbox-sm': { css: coverbox.sm },
      'coverbox-lg': { css: coverbox.lg },
    };
  };

module.exports = prose;
